import { Grid } from "@mui/material";

type Props = {
  leftPanelGridWidth: number;
  rightPanelGridWidth: number;
  leftWidget: JSX.Element;
  rightWidget: JSX.Element;
};

export const PanelLayout = ({
  leftPanelGridWidth,
  rightPanelGridWidth,
  leftWidget,
  rightWidget,
}: Props) => {
  return (
    <Grid container>
      <Grid item xs={leftPanelGridWidth}>
        {leftWidget}
      </Grid>
      <Grid
        item
        xs={rightPanelGridWidth}
        sx={{
          backgroundColor: "#EAEAF1",
          borderRadius: "16px",
        }}
      >
        {rightWidget}
      </Grid>
    </Grid>
  );
};
